import React, { useEffect, useState } from 'react'

export default function TotalInfo(props) {
	
	const { deenergized, deenergized_sum, panels } = props
	
	const [ind_ee, setInd_ee] = useState({})
	const [ind_t, setInd_t] = useState({})
	const [ind_g, setInd_g] = useState({})
	const [total, setTotal] = useState([])
	
	useEffect(() => {
		setInd_ee(panels.find(e => e.ind === 'ee'))
		setInd_t(panels.find(e => e.ind === 't'))
		setInd_g(panels.find(e => e.ind === 'g'))
	}, [panels])
	
	const draw = (key, val, style, onClick) => val > 0 && <div className={`kv-panel ${style}`} onClick={() => onClick && onClick('all')}>
				<div className="kv-val">{val}</div>
				<div className="kv-key">{key}</div>
			</div>
	
	useEffect(() => {
		let _total = []
		deenergized.forEach(e => {
			let _head = _total.find(el => el.head === e.head_company)
			if (_head === undefined) {
				_head = {
					head: e.head_company,
					sum: 0
				}
				_total.push(_head)
			}
			_head.sum += +e.population
		})
		_total.sort((a, b) => b.sum - a.sum)
		setTotal(_total)
	}, [deenergized])
	
	return <div className="flex m-4">
		
		{draw('Откл. абонентов (компании)', deenergized_sum, 'mw14 red', props.onShowDeenergized)}
		
		<div className="kv-panel-group">
			{draw('Обесточено населения', ind_ee?.consumers, 'mw14')}
			{draw('Откл. точек поставки', ind_ee?.endpoints, 'mw12')}
			{draw('Откл. мощность (МВт)', ind_ee?.power, 'mw12')}
		</div>
		
		{draw('Обесточено нас. пунктов', ind_ee?.cities, 'mw14')}
		
		<div className="kv-panel-group">
			{draw('Работает бригад', ind_ee?.avr, 'mw10')}
			{draw('Единиц техники', ind_ee?.units, 'mw10')}
			{draw('Человек', ind_ee?.personnel, 'mw10')}
		</div>
		
		{draw('Население без тепла (чел)', +(ind_t?.consumers ?? 0) + +(ind_t?.endpoints ?? 0), 'mw14')}
		
		{draw('Абонентов без газа', +(ind_g?.consumers ?? 0) + +(ind_g?.endpoints ?? 0), 'mw14')}
		
	</div>
	
}

